<template>
  <div class="layout">
    <div class="layout__header">
      <h3>Observación</h3>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-field">
          <textarea-field
            maxlength="1000"
            v-model="form.observacion"
            placeholder="Escriba un comentario..."
            id="comentario"
          >
            <span>Comentario</span>
          </textarea-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cerrar" class="btn-success" type="button">
        <i class="fa fa-check"></i>
        <span>Cerrar</span>
      </button>
      <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button">
        <i class="fa fa-ban"></i>
        <span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false,
      default: function() {
        return "";
      }
    }
  },
  data: function() {
    return {
      form: {
        observacion: ""
      }
    };
  },
  methods: {
    cerrar: function() {
      if (this.form.observacion !== "") {
        let that = this;
        swal({
          title: "¿Desea cerrar esta orden de trabajo?",
          text: "Esta acción requiere de confirmación.",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Cerrar",
          cancelButtonText: "No"
        }).then(function(result) {
          if (result.value) {
            axios
              .post(url + "/orden-trabajo/" + that.id, that.form)
              .then(function(response) {
                swal(
                  "La orden de trabajo ha sido cerrada.",
                  "Aviso",
                  "success"
                );
                that.$emit(
                  "cerrada",
                  that.form.observacion,
                  response.data.estado
                );
              })
              .catch(function() {
                swal("Hubo un error, intente nuevamente.", "Aviso", "warning");
              });
          }
        });
      } else swal("Debe ingresar una observación.", "Aviso", "warning");
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ordenes-trabajo/ObservacionOT.vue